import { baseAPI } from "../baseApi";

export const transportApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение всех типов покрытий для базы с их протяженностью
        fetchTransport: builder.query<any, any>({
            query: (args) => ({
                url: `transport/get`
            })
        }),
        fetchTransportById: builder.query<any, any>({
            query: (args) => ({
                url: `transport/get?id=${args?.id}`
            })
        }),
        fetchTransportDrivewaysList: builder.query<any, any>({
            query: (args) => ({
                url: `transport/driveways/list`
            })
        }),
        fetchDrivewaysByTransportId: builder.query<any,any>({
            query: (args) => ({
                url: `transport/driveways/get?lon=${args.lon}&lat=${args.lat}&objectId=${args.transportId}&date=${args.date}`
            })
        })
    })
})

export const {
    useFetchTransportQuery,
    useFetchTransportByIdQuery,
    useFetchTransportDrivewaysListQuery,
    useFetchDrivewaysByTransportIdQuery
} = transportApiSlice